/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_CrumbInputs */

const th_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ดูแลระบบ`)
};

const en_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const ja_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const es_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración`)
};

const pt_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administração`)
};

const id_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrasi`)
};

const fr_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration`)
};

const tl_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangangasiwa`)
};

const vi_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản trị`)
};

const ko_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리`)
};

const de_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwaltung`)
};

const ru_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Администрирование`)
};

const tr_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönetim`)
};

const it_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amministrazione`)
};

const pl_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administracja`)
};

const uk_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адміністрування`)
};

const hi_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रशासन`)
};

const ar_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإدارة`)
};

const ms_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentadbiran`)
};

const bn_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রশাসন`)
};

const zh_tw2_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_hk2_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const ur_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتظامیہ`)
};

const fa_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدیریت`)
};

const sw_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uendeshaji`)
};

const nl_admin_crumb = /** @type {(inputs: Admin_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Admin_CrumbInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_crumb = /** @type {((inputs?: Admin_CrumbInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_CrumbInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_crumb(inputs)
	if (locale === "ja") return ja_admin_crumb(inputs)
	if (locale === "zh") return zh_admin_crumb(inputs)
	if (locale === "es") return es_admin_crumb(inputs)
	if (locale === "pt") return pt_admin_crumb(inputs)
	if (locale === "id") return id_admin_crumb(inputs)
	if (locale === "fr") return fr_admin_crumb(inputs)
	if (locale === "tl") return tl_admin_crumb(inputs)
	if (locale === "vi") return vi_admin_crumb(inputs)
	if (locale === "ko") return ko_admin_crumb(inputs)
	if (locale === "de") return de_admin_crumb(inputs)
	if (locale === "ru") return ru_admin_crumb(inputs)
	if (locale === "tr") return tr_admin_crumb(inputs)
	if (locale === "it") return it_admin_crumb(inputs)
	if (locale === "pl") return pl_admin_crumb(inputs)
	if (locale === "uk") return uk_admin_crumb(inputs)
	if (locale === "hi") return hi_admin_crumb(inputs)
	if (locale === "ar") return ar_admin_crumb(inputs)
	if (locale === "ms") return ms_admin_crumb(inputs)
	if (locale === "bn") return bn_admin_crumb(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_crumb(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_crumb(inputs)
	if (locale === "ur") return ur_admin_crumb(inputs)
	if (locale === "fa") return fa_admin_crumb(inputs)
	if (locale === "sw") return sw_admin_crumb(inputs)
	if (locale === "nl") return nl_admin_crumb(inputs)
	return en_admin_crumb(inputs)
});